module.exports = __webpack_public_path__ + "static/img/1.b9afd6f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/12/sp/1.png
// module id = wBe9
// module chunks = 0